export var triggerWindowResize = function () {
    window.dispatchEvent(new Event('resize'));
};
